module.exports = __webpack_public_path__ + "img/checklist-button-chest2.b9f67193.png";